var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomRightBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0.5H24.25V16C24.25 20.1421 20.8921 23.5 16.75 23.5H1.25V0.5Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0.5H24.25V16C24.25 20.1421 20.8921 23.5 16.75 23.5H1.25V0.5Z",
    stroke: "#939393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4697 18.7192C19.2546 18.9343 18.9864 18.9946 18.7328 19.0076C18.4983 19.0195 18.207 18.993 17.8792 18.9632L17.0891 18.8914C16.533 18.8408 16.067 18.7985 15.7254 18.7167C15.3836 18.6349 15.0035 18.4768 14.8549 18.0664C14.7063 17.656 14.8971 17.2912 15.1073 17.0096C15.3071 16.7419 15.616 16.4297 15.9852 16.0603L11.9104 11.9855C11.6827 11.7577 11.6827 11.3884 11.9104 11.1606C12.1382 10.9328 12.5076 10.9328 12.7354 11.1606L16.8102 15.2353C17.1798 14.8659 17.4922 14.5567 17.7601 14.3568C18.0417 14.1466 18.4065 13.9558 18.8169 14.1044C19.2273 14.253 19.3854 14.6331 19.4672 14.9749C19.549 15.3166 19.5913 15.7826 19.6418 16.3386L19.7137 17.1287C19.7435 17.4565 19.77 17.7478 19.7581 17.9823C19.7451 18.2359 19.6848 18.5041 19.4697 18.7192Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRightBorder);
export default __webpack_public_path__ + "static/media/BottomRightBorder.97abbccc3281327b235fe8ffb1fe05ba.svg";
export { ForwardRef as ReactComponent };